// extracted by mini-css-extract-plugin
module.exports = {"signupReminder":"styles_signupReminder__16aPr"};